import { APPID, LOGIN_DATA, LOGIN_TOKEN, USER_CODE, USER_SIGN } from '@/types';
import {LOGIN_ROLE} from "../config/types";

export interface ILoginData {
	[APPID] : number;
	[USER_CODE] : string;
	[USER_SIGN] : string;
	[LOGIN_TOKEN] : string | null;
}

class Cache {
	storage : Storage | undefined;

	setCache(key : string, value : any) {
		if (value) {
			uni.setStorageSync(key, JSON.stringify(value));
		}
	}

	getCache(key : string) {
		const value = uni.getStorageSync(key);
		if (value) {
			return JSON.parse(value);
		} else {
			return null
		}
	}

	getLoginCache() : ILoginData | null {
		const value = this.getCache(LOGIN_DATA);
		const token = this.getCache(LOGIN_TOKEN);
		if (value) {
			return {
				[APPID]: value.appId,
				[USER_CODE]: value.userCode,
				[USER_SIGN]: value.sing,
				[LOGIN_TOKEN]: token
			};
		}
		return null;
	}

	getLoginAttr(key : string) {
		const value = this.getCache(LOGIN_DATA);
		if (value) {
			return value[key];
		}
		return null;
	}

	setLoginCache(data : any) {
		const token = data.token || data.access_token;
		this.setCache(LOGIN_DATA, data);
		this.setCache(LOGIN_TOKEN, token);
	}

	clearLoginCache() {
		this.removeCache(LOGIN_DATA);
		this.removeCache(LOGIN_TOKEN);
		this.removeCache(LOGIN_ROLE);
	}

	getCacheToken() {
		return this.getCache(LOGIN_TOKEN);
	}

	getLoginRole() {
		return this.getCache(LOGIN_ROLE);
	}


	removeCache(key : string) {
		uni.removeStorageSync(key);
	}

	clear() {
		uni.clearStorageSync();
	}
}

const localCache = new Cache();
export { localCache };